import { useEffect, useState } from "react";
import { subscribeChapters } from "@/lib/firestore/chapters";
import type { Chapter } from "@/types";

export function useChapters(projectId: string | null) {
  const [chapters, setChapters] = useState<Chapter[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!projectId) {
      setChapters([]);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    return subscribeChapters(
      projectId,
      (data) => {
        setChapters(data);
        setLoading(false);
        setError(null);
      },
      (err) => {
        setError(err.message);
        setLoading(false);
      },
    );
  }, [projectId]);

  return { chapters, loading, error };
}
